export default __webpack_public_path__ + "static/media/model-attribute-new.f79dec8e.png";